webpackJsonp([107818501498521],{

/***/ 435:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* eslint-env amd, node */
	
	// https://github.com/umdjs/umd/blob/master/templates/returnExports.js
	(function (root, factory) {
	  'use strict';
	
	  if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module === 'object' && module.exports) {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory();
	  } else {
	    // Browser globals (root is window)
	    root.AnchorJS = factory();
	    root.anchors = new root.AnchorJS();
	  }
	}(this, function () {
	  'use strict';
	
	  function AnchorJS(options) {
	    this.options = options || {};
	    this.elements = [];
	
	    /**
	     * Assigns options to the internal options object, and provides defaults.
	     * @param {Object} opts - Options object
	     */
	    function _applyRemainingDefaultOptions(opts) {
	      opts.icon = opts.hasOwnProperty('icon') ? opts.icon : '\ue9cb'; // Accepts characters (and also URLs?), like  '#', '¶', '❡', or '§'.
	      opts.visible = opts.hasOwnProperty('visible') ? opts.visible : 'hover'; // Also accepts 'always' & 'touch'
	      opts.placement = opts.hasOwnProperty('placement') ? opts.placement : 'right'; // Also accepts 'left'
	      opts.ariaLabel = opts.hasOwnProperty('ariaLabel') ? opts.ariaLabel : 'Anchor'; // Accepts any text.
	      opts.class = opts.hasOwnProperty('class') ? opts.class : ''; // Accepts any class name.
	      // Using Math.floor here will ensure the value is Number-cast and an integer.
	      opts.truncate = opts.hasOwnProperty('truncate') ? Math.floor(opts.truncate) : 64; // Accepts any value that can be typecast to a number.
	    }
	
	    _applyRemainingDefaultOptions(this.options);
	
	    /**
	     * Checks to see if this device supports touch. Uses criteria pulled from Modernizr:
	     * https://github.com/Modernizr/Modernizr/blob/da22eb27631fc4957f67607fe6042e85c0a84656/feature-detects/touchevents.js#L40
	     * @return {Boolean} - true if the current device supports touch.
	     */
	    this.isTouchDevice = function() {
	      return !!(('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch);
	    };
	
	    /**
	     * Add anchor links to page elements.
	     * @param  {String|Array|Nodelist} selector - A CSS selector for targeting the elements you wish to add anchor links
	     *                                            to. Also accepts an array or nodeList containing the relavant elements.
	     * @return {this}                           - The AnchorJS object
	     */
	    this.add = function(selector) {
	      var elements,
	          elsWithIds,
	          idList,
	          elementID,
	          i,
	          index,
	          count,
	          tidyText,
	          newTidyText,
	          readableID,
	          anchor,
	          visibleOptionToUse,
	          indexesToDrop = [];
	
	      // We reapply options here because somebody may have overwritten the default options object when setting options.
	      // For example, this overwrites all options but visible:
	      //
	      // anchors.options = { visible: 'always'; }
	      _applyRemainingDefaultOptions(this.options);
	
	      visibleOptionToUse = this.options.visible;
	      if (visibleOptionToUse === 'touch') {
	        visibleOptionToUse = this.isTouchDevice() ? 'always' : 'hover';
	      }
	
	      // Provide a sensible default selector, if none is given.
	      if (!selector) {
	        selector = 'h2, h3, h4, h5, h6';
	      }
	
	      elements = _getElements(selector);
	
	      if (elements.length === 0) {
	        return this;
	      }
	
	      _addBaselineStyles();
	
	      // We produce a list of existing IDs so we don't generate a duplicate.
	      elsWithIds = document.querySelectorAll('[id]');
	      idList = [].map.call(elsWithIds, function assign(el) {
	        return el.id;
	      });
	
	      for (i = 0; i < elements.length; i++) {
	        if (this.hasAnchorJSLink(elements[i])) {
	          indexesToDrop.push(i);
	          continue;
	        }
	
	        if (elements[i].hasAttribute('id')) {
	          elementID = elements[i].getAttribute('id');
	        } else if (elements[i].hasAttribute('data-anchor-id')) {
	          elementID = elements[i].getAttribute('data-anchor-id');
	        } else {
	          tidyText = this.urlify(elements[i].textContent);
	
	          // Compare our generated ID to existing IDs (and increment it if needed)
	          // before we add it to the page.
	          newTidyText = tidyText;
	          count = 0;
	          do {
	            if (index !== undefined) {
	              newTidyText = tidyText + '-' + count;
	            }
	
	            index = idList.indexOf(newTidyText);
	            count += 1;
	          } while (index !== -1);
	          index = undefined;
	          idList.push(newTidyText);
	
	          elements[i].setAttribute('id', newTidyText);
	          elementID = newTidyText;
	        }
	
	        readableID = elementID.replace(/-/g, ' ');
	
	        // The following code builds the following DOM structure in a more effiecient (albeit opaque) way.
	        // '<a class="anchorjs-link ' + this.options.class + '" href="#' + elementID + '" aria-label="Anchor" data-anchorjs-icon="' + this.options.icon + '"></a>';
	        anchor = document.createElement('a');
	        anchor.className = 'anchorjs-link ' + this.options.class;
	        anchor.href = '#' + elementID;
	        anchor.setAttribute('aria-label', this.options.ariaLabel);
	        anchor.setAttribute('data-anchorjs-icon', this.options.icon);
	
	        if (visibleOptionToUse === 'always') {
	          anchor.style.opacity = '1';
	        }
	
	        if (this.options.icon === '\ue9cb') {
	          anchor.style.font = '1em/1 anchorjs-icons';
	
	          // We set lineHeight = 1 here because the `anchorjs-icons` font family could otherwise affect the
	          // height of the heading. This isn't the case for icons with `placement: left`, so we restore
	          // line-height: inherit in that case, ensuring they remain positioned correctly. For more info,
	          // see https://github.com/bryanbraun/anchorjs/issues/39.
	          if (this.options.placement === 'left') {
	            anchor.style.lineHeight = 'inherit';
	          }
	        }
	
	        if (this.options.placement === 'left') {
	          anchor.style.position = 'absolute';
	          anchor.style.marginLeft = '-1em';
	          anchor.style.paddingRight = '0.5em';
	          elements[i].insertBefore(anchor, elements[i].firstChild);
	        } else { // if the option provided is `right` (or anything else).
	          anchor.style.paddingLeft = '0.375em';
	          elements[i].appendChild(anchor);
	        }
	      }
	
	      for (i = 0; i < indexesToDrop.length; i++) {
	        elements.splice(indexesToDrop[i] - i, 1);
	      }
	      this.elements = this.elements.concat(elements);
	
	      return this;
	    };
	
	    /**
	     * Removes all anchorjs-links from elements targed by the selector.
	     * @param  {String|Array|Nodelist} selector - A CSS selector string targeting elements with anchor links,
	     *                                            OR a nodeList / array containing the DOM elements.
	     * @return {this}                           - The AnchorJS object
	     */
	    this.remove = function(selector) {
	      var index,
	          domAnchor,
	          elements = _getElements(selector);
	
	      for (var i = 0; i < elements.length; i++) {
	        domAnchor = elements[i].querySelector('.anchorjs-link');
	        if (domAnchor) {
	          // Drop the element from our main list, if it's in there.
	          index = this.elements.indexOf(elements[i]);
	          if (index !== -1) {
	            this.elements.splice(index, 1);
	          }
	          // Remove the anchor from the DOM.
	          elements[i].removeChild(domAnchor);
	        }
	      }
	      return this;
	    };
	
	    /**
	     * Removes all anchorjs links. Mostly used for tests.
	     */
	    this.removeAll = function() {
	      this.remove(this.elements);
	    };
	
	    /**
	     * Urlify - Refine text so it makes a good ID.
	     *
	     * To do this, we remove apostrophes, replace nonsafe characters with hyphens,
	     * remove extra hyphens, truncate, trim hyphens, and make lowercase.
	     *
	     * @param  {String} text - Any text. Usually pulled from the webpage element we are linking to.
	     * @return {String}      - hyphen-delimited text for use in IDs and URLs.
	     */
	    this.urlify = function(text) {
	      // Regex for finding the nonsafe URL characters (many need escaping): & +$,:;=?@"#{}|^~[`%!'<>]./()*\
	      var nonsafeChars = /[& +$,:;=?@"#{}|^~[`%!'<>\]\.\/\(\)\*\\]/g,
	          urlText;
	
	      // The reason we include this _applyRemainingDefaultOptions is so urlify can be called independently,
	      // even after setting options. This can be useful for tests or other applications.
	      if (!this.options.truncate) {
	        _applyRemainingDefaultOptions(this.options);
	      }
	
	      // Note: we trim hyphens after truncating because truncating can cause dangling hyphens.
	      // Example string:                      // " ⚡⚡ Don't forget: URL fragments should be i18n-friendly, hyphenated, short, and clean."
	      urlText = text.trim()                   // "⚡⚡ Don't forget: URL fragments should be i18n-friendly, hyphenated, short, and clean."
	        .replace(/\'/gi, '')                  // "⚡⚡ Dont forget: URL fragments should be i18n-friendly, hyphenated, short, and clean."
	        .replace(nonsafeChars, '-')           // "⚡⚡-Dont-forget--URL-fragments-should-be-i18n-friendly--hyphenated--short--and-clean-"
	        .replace(/-{2,}/g, '-')               // "⚡⚡-Dont-forget-URL-fragments-should-be-i18n-friendly-hyphenated-short-and-clean-"
	        .substring(0, this.options.truncate)  // "⚡⚡-Dont-forget-URL-fragments-should-be-i18n-friendly-hyphenated-"
	        .replace(/^-+|-+$/gm, '')             // "⚡⚡-Dont-forget-URL-fragments-should-be-i18n-friendly-hyphenated"
	        .toLowerCase();                       // "⚡⚡-dont-forget-url-fragments-should-be-i18n-friendly-hyphenated"
	
	      return urlText;
	    };
	
	    /**
	     * Determines if this element already has an AnchorJS link on it.
	     * Uses this technique: http://stackoverflow.com/a/5898748/1154642
	     * @param    {HTMLElemnt}  el - a DOM node
	     * @return   {Boolean}     true/false
	     */
	    this.hasAnchorJSLink = function(el) {
	      var hasLeftAnchor = el.firstChild && ((' ' + el.firstChild.className + ' ').indexOf(' anchorjs-link ') > -1),
	          hasRightAnchor = el.lastChild && ((' ' + el.lastChild.className + ' ').indexOf(' anchorjs-link ') > -1);
	
	      return hasLeftAnchor || hasRightAnchor || false;
	    };
	
	    /**
	     * Turns a selector, nodeList, or array of elements into an array of elements (so we can use array methods).
	     * It also throws errors on any other inputs. Used to handle inputs to .add and .remove.
	     * @param  {String|Array|Nodelist} input - A CSS selector string targeting elements with anchor links,
	     *                                         OR a nodeList / array containing the DOM elements.
	     * @return {Array} - An array containing the elements we want.
	     */
	    function _getElements(input) {
	      var elements;
	      if (typeof input === 'string' || input instanceof String) {
	        // See https://davidwalsh.name/nodelist-array for the technique transforming nodeList -> Array.
	        elements = [].slice.call(document.querySelectorAll(input));
	      // I checked the 'input instanceof NodeList' test in IE9 and modern browsers and it worked for me.
	      } else if (Array.isArray(input) || input instanceof NodeList) {
	        elements = [].slice.call(input);
	      } else {
	        throw new Error('The selector provided to AnchorJS was invalid.');
	      }
	      return elements;
	    }
	
	    /**
	     * _addBaselineStyles
	     * Adds baseline styles to the page, used by all AnchorJS links irregardless of configuration.
	     */
	    function _addBaselineStyles() {
	      // We don't want to add global baseline styles if they've been added before.
	      if (document.head.querySelector('style.anchorjs') !== null) {
	        return;
	      }
	
	      var style = document.createElement('style'),
	          linkRule =
	          ' .anchorjs-link {'                       +
	          '   opacity: 0;'                          +
	          '   text-decoration: none;'               +
	          '   -webkit-font-smoothing: antialiased;' +
	          '   -moz-osx-font-smoothing: grayscale;'  +
	          ' }',
	          hoverRule =
	          ' *:hover > .anchorjs-link,'              +
	          ' .anchorjs-link:focus  {'                +
	          '   opacity: 1;'                          +
	          ' }',
	          anchorjsLinkFontFace =
	          ' @font-face {'                           +
	          '   font-family: "anchorjs-icons";'       + // Icon from icomoon; 10px wide & 10px tall; 2 empty below & 4 above
	          '   src: url(data:n/a;base64,AAEAAAALAIAAAwAwT1MvMg8yG2cAAAE4AAAAYGNtYXDp3gC3AAABpAAAAExnYXNwAAAAEAAAA9wAAAAIZ2x5ZlQCcfwAAAH4AAABCGhlYWQHFvHyAAAAvAAAADZoaGVhBnACFwAAAPQAAAAkaG10eASAADEAAAGYAAAADGxvY2EACACEAAAB8AAAAAhtYXhwAAYAVwAAARgAAAAgbmFtZQGOH9cAAAMAAAAAunBvc3QAAwAAAAADvAAAACAAAQAAAAEAAHzE2p9fDzz1AAkEAAAAAADRecUWAAAAANQA6R8AAAAAAoACwAAAAAgAAgAAAAAAAAABAAADwP/AAAACgAAA/9MCrQABAAAAAAAAAAAAAAAAAAAAAwABAAAAAwBVAAIAAAAAAAIAAAAAAAAAAAAAAAAAAAAAAAMCQAGQAAUAAAKZAswAAACPApkCzAAAAesAMwEJAAAAAAAAAAAAAAAAAAAAARAAAAAAAAAAAAAAAAAAAAAAQAAg//0DwP/AAEADwABAAAAAAQAAAAAAAAAAAAAAIAAAAAAAAAIAAAACgAAxAAAAAwAAAAMAAAAcAAEAAwAAABwAAwABAAAAHAAEADAAAAAIAAgAAgAAACDpy//9//8AAAAg6cv//f///+EWNwADAAEAAAAAAAAAAAAAAAAACACEAAEAAAAAAAAAAAAAAAAxAAACAAQARAKAAsAAKwBUAAABIiYnJjQ3NzY2MzIWFxYUBwcGIicmNDc3NjQnJiYjIgYHBwYUFxYUBwYGIwciJicmNDc3NjIXFhQHBwYUFxYWMzI2Nzc2NCcmNDc2MhcWFAcHBgYjARQGDAUtLXoWOR8fORYtLTgKGwoKCjgaGg0gEhIgDXoaGgkJBQwHdR85Fi0tOAobCgoKOBoaDSASEiANehoaCQkKGwotLXoWOR8BMwUFLYEuehYXFxYugC44CQkKGwo4GkoaDQ0NDXoaShoKGwoFBe8XFi6ALjgJCQobCjgaShoNDQ0NehpKGgobCgoKLYEuehYXAAAADACWAAEAAAAAAAEACAAAAAEAAAAAAAIAAwAIAAEAAAAAAAMACAAAAAEAAAAAAAQACAAAAAEAAAAAAAUAAQALAAEAAAAAAAYACAAAAAMAAQQJAAEAEAAMAAMAAQQJAAIABgAcAAMAAQQJAAMAEAAMAAMAAQQJAAQAEAAMAAMAAQQJAAUAAgAiAAMAAQQJAAYAEAAMYW5jaG9yanM0MDBAAGEAbgBjAGgAbwByAGoAcwA0ADAAMABAAAAAAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAAH//wAP) format("truetype");' +
	          ' }',
	          pseudoElContent =
	          ' [data-anchorjs-icon]::after {'          +
	          '   content: attr(data-anchorjs-icon);'   +
	          ' }',
	          firstStyleEl;
	
	      style.className = 'anchorjs';
	      style.appendChild(document.createTextNode('')); // Necessary for Webkit.
	
	      // We place it in the head with the other style tags, if possible, so as to
	      // not look out of place. We insert before the others so these styles can be
	      // overridden if necessary.
	      firstStyleEl = document.head.querySelector('[rel="stylesheet"], style');
	      if (firstStyleEl === undefined) {
	        document.head.appendChild(style);
	      } else {
	        document.head.insertBefore(style, firstStyleEl);
	      }
	
	      style.sheet.insertRule(linkRule, style.sheet.cssRules.length);
	      style.sheet.insertRule(hoverRule, style.sheet.cssRules.length);
	      style.sheet.insertRule(pseudoElContent, style.sheet.cssRules.length);
	      style.sheet.insertRule(anchorjsLinkFontFace, style.sheet.cssRules.length);
	    }
	  }
	
	  return AnchorJS;
	}));


/***/ }),

/***/ 1454:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var DISQUS_CONFIG = ['shortname', 'identifier', 'title', 'url', 'category_id', 'onNewComment', 'language'];
	var __disqusAdded = false;
	
	function copyProps(context, props) {
	    var onNewComment = props.onNewComment,
	        language = props.language,
	        rest = _objectWithoutProperties(props, ['onNewComment', 'language']);
	
	    for (var prop in rest) {
	        context.page[prop] = rest[prop];
	    }
	
	    // Setting the language - if none is provided, the default one is used
	    context.language = language;
	
	    if (onNewComment) {
	        context.callbacks = {
	            onNewComment: [onNewComment]
	        };
	    }
	}
	
	var DisqusThread = function (_React$Component) {
	    _inherits(DisqusThread, _React$Component);
	
	    function DisqusThread() {
	        _classCallCheck(this, DisqusThread);
	
	        return _possibleConstructorReturn(this, (DisqusThread.__proto__ || Object.getPrototypeOf(DisqusThread)).apply(this, arguments));
	    }
	
	    _createClass(DisqusThread, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.loadDisqus();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            this.loadDisqus();
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            return nextProps.identifier !== this.props.identifier;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var props = Object.keys(this.props).reduce(function (memo, key) {
	                return DISQUS_CONFIG.some(function (config) {
	                    return config === key;
	                }) ? memo : _extends({}, memo, _defineProperty({}, key, _this2.props[key]));
	            }, {});
	
	            return _react2.default.createElement(
	                'div',
	                props,
	                _react2.default.createElement('div', { id: 'disqus_thread' })
	            );
	        }
	    }, {
	        key: 'addDisqusScript',
	        value: function addDisqusScript() {
	            if (__disqusAdded) {
	                return;
	            }
	
	            var child = this.disqus = document.createElement('script');
	            var parent = document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0];
	
	            child.async = true;
	            child.type = 'text/javascript';
	            child.src = '//' + this.props.shortname + '.disqus.com/embed.js';
	
	            parent.appendChild(child);
	            __disqusAdded = true;
	        }
	    }, {
	        key: 'loadDisqus',
	        value: function loadDisqus() {
	            var _this3 = this;
	
	            var props = {};
	
	            // Extract Disqus props that were supplied to this component
	            DISQUS_CONFIG.forEach(function (prop) {
	                // prop "shortname" is only necessary for loading the script, not for the config itself
	                if (prop !== 'shortname' && !!_this3.props[prop]) {
	                    props[prop] = _this3.props[prop];
	                }
	            });
	
	            // If Disqus has already been added, reset it
	            if (typeof DISQUS !== 'undefined') {
	                DISQUS.reset({
	                    reload: true,
	                    config: function config() {
	                        copyProps(this, props);
	
	                        // Disqus needs hashbang URL, see https://help.disqus.com/customer/portal/articles/472107
	                        this.page.url = this.page.url.replace(/#/, '') + '#!newthread';
	                    }
	                });
	            } else {
	                // Otherwise add Disqus to the page
	                window.disqus_config = function () {
	                    copyProps(this, props);
	                };
	                this.addDisqusScript();
	            }
	        }
	    }]);
	
	    return DisqusThread;
	}(_react2.default.Component);
	
	DisqusThread.displayName = 'DisqusThread';
	
	DisqusThread.propTypes = {
	    id: _propTypes2.default.string,
	
	    /**
	     * `shortname` tells the Disqus service your forum's shortname,
	     * which is the unique identifier for your website as registered
	     * on Disqus. If undefined , the Disqus embed will not load.
	     */
	    shortname: _propTypes2.default.string.isRequired,
	
	    /**
	     * `identifier` tells the Disqus service how to identify the
	     * current page. When the Disqus embed is loaded, the identifier
	     * is used to look up the correct thread. If disqus_identifier
	     * is undefined, the page's URL will be used. The URL can be
	     * unreliable, such as when renaming an article slug or changing
	     * domains, so we recommend using your own unique way of
	     * identifying a thread.
	     */
	    identifier: _propTypes2.default.string,
	
	    /**
	     * `title` tells the Disqus service the title of the current page.
	     * This is used when creating the thread on Disqus for the first time.
	     * If undefined, Disqus will use the <title> attribute of the page.
	     * If that attribute could not be used, Disqus will use the URL of the page.
	     */
	    title: _propTypes2.default.string,
	
	    /**
	     * `url` tells the Disqus service the URL of the current page.
	     * If undefined, Disqus will take the window.location.href.
	     * This URL is used to look up or create a thread if disqus_identifier
	     * is undefined. In addition, this URL is always saved when a thread is
	     * being created so that Disqus knows what page a thread belongs to.
	     */
	    url: _propTypes2.default.string,
	
	    /**
	     * `category_id` tells the Disqus service the category to be used for
	     * the current page. This is used when creating the thread on Disqus
	     * for the first time.
	     */
	    category_id: _propTypes2.default.string,
	
	    /**
	     * `onNewComment` function accepts one parameter `comment` which is a
	     * JavaScript object with comment `id` and `text`. This allows you to track
	     * user comments and replies and run a script after a comment is posted.
	     */
	    onNewComment: _propTypes2.default.func,
	
	    /**
	     * `language` tells the Disqus service which language should be used.
	     * Please refer to https://www.transifex.com/disqus/disqus/ on which languages can be used
	     * If undefined, English is used as default one
	     */
	    language: _propTypes2.default.string
	};
	
	DisqusThread.defaultProps = {
	    url: typeof window === 'undefined' ? null : window.location.href
	};
	
	exports.default = DisqusThread;

/***/ }),

/***/ 1455:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(1454);

/***/ }),

/***/ 1458:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(9);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaEdit = function FaEdit(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm19.8 26.4l2.6-2.6-3.4-3.4-2.6 2.6v1.3h2.2v2.1h1.2z m9.8-16q-0.3-0.4-0.7 0l-7.8 7.8q-0.4 0.4 0 0.7t0.7 0l7.8-7.8q0.4-0.4 0-0.7z m1.8 13.2v4.3q0 2.6-1.9 4.5t-4.5 1.9h-18.6q-2.6 0-4.5-1.9t-1.9-4.5v-18.6q0-2.7 1.9-4.6t4.5-1.8h18.6q1.4 0 2.6 0.5 0.3 0.2 0.4 0.5 0.1 0.4-0.2 0.7l-1.1 1.1q-0.3 0.3-0.7 0.1-0.5-0.1-1-0.1h-18.6q-1.4 0-2.5 1.1t-1 2.5v18.6q0 1.4 1 2.5t2.5 1h18.6q1.5 0 2.5-1t1.1-2.5v-2.9q0-0.2 0.2-0.4l1.4-1.5q0.3-0.3 0.8-0.1t0.4 0.6z m-2.1-16.5l6.4 6.5-15 15h-6.4v-6.5z m9.9 3l-2.1 2-6.4-6.4 2.1-2q0.6-0.7 1.5-0.7t1.5 0.7l3.4 3.4q0.6 0.6 0.6 1.5t-0.6 1.5z' })
	        )
	    );
	};
	
	exports.default = FaEdit;
	module.exports = exports['default'];

/***/ }),

/***/ 448:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  margin: ', ' 0;\n'], ['\n  margin: ', ' 0;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDisqusComments = __webpack_require__(1455);
	
	var _reactDisqusComments2 = _interopRequireDefault(_reactDisqusComments);
	
	var _styledComponents = __webpack_require__(6);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Comments = function (_React$PureComponent) {
	  _inherits(Comments, _React$PureComponent);
	
	  function Comments() {
	    _classCallCheck(this, Comments);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  Comments.prototype.handleNewComment = function handleNewComment(comment) {
	    console.log(comment.text);
	  };
	
	  Comments.prototype.render = function render() {
	
	    return _react2.default.createElement(_reactDisqusComments2.default, _extends({
	      onNewComment: this.handleNewComment
	    }, this.props));
	  };
	
	  return Comments;
	}(_react2.default.PureComponent);
	
	Comments.propTypes = {
	  shortname: _propTypes2.default.string,
	  identifier: _propTypes2.default.string,
	  title: _propTypes2.default.string,
	  url: _propTypes2.default.string,
	  category_id: _propTypes2.default.string
	};
	exports.default = (0, _styledComponents2.default)(Comments)(_templateObject, function (_ref) {
	  var theme = _ref.theme;
	  return theme.scale(6);
	});
	module.exports = exports['default'];

/***/ }),

/***/ 449:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: block;\n  text-align: center;\n  padding: 1rem;\n  color: ', ';\n  cursor: pointer;\n  font-size: 1rem;\n  transition: 0.3s;\n\n  &:hover{\n    transition: 0.3s;\n    color: ', ';\n  }\n'], ['\n  display: block;\n  text-align: center;\n  padding: 1rem;\n  color: ', ';\n  cursor: pointer;\n  font-size: 1rem;\n  transition: 0.3s;\n\n  &:hover{\n    transition: 0.3s;\n    color: ', ';\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  padding: 0 ', ' 0 0;\n'], ['\n  padding: 0 ', ' 0 0;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(6);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _edit = __webpack_require__(1458);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var A = _styledComponents2.default.a(_templateObject, function (_ref) {
	  var theme = _ref.theme;
	  return theme.colors.yellow;
	}, function (_ref2) {
	  var theme = _ref2.theme;
	  return theme.colors.white;
	});
	
	var EditIcon = (0, _styledComponents2.default)(_edit2.default)(_templateObject2, function (_ref3) {
	  var theme = _ref3.theme;
	  return theme.scale(-8);
	});
	
	var getEditLink = function getEditLink(fileAbsolutePath) {
	  var path = fileAbsolutePath.split('/src/')[1];
	  return 'https://github.com/angeloocana/angeloocana/blob/master/src/' + path;
	};
	
	var getLabel = function getLabel() {
	  return {
	    en: 'Edit',
	    fr: 'Modifier',
	    pt: 'Editar'
	  };
	};
	
	var EditBtn = function EditBtn(_ref4) {
	  var fileAbsolutePath = _ref4.fileAbsolutePath,
	      currentLangKey = _ref4.currentLangKey;
	
	  return _react2.default.createElement(
	    A,
	    { href: getEditLink(fileAbsolutePath), target: '_blank' },
	    _react2.default.createElement(EditIcon, null),
	    getLabel()[currentLangKey]
	  );
	};
	
	EditBtn.propTypes = {
	  fileAbsolutePath: _propTypes2.default.string,
	  currentLangKey: _propTypes2.default.string
	};
	
	exports.default = EditBtn;
	module.exports = exports['default'];

/***/ }),

/***/ 457:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  text-align: center;\n  margin: 1rem;\n  padding: 0;\n'], ['\n  text-align: center;\n  margin: 1rem;\n  padding: 0;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    padding: ', ' 0;\n    display: block;\n'], ['\n    padding: ', ' 0;\n    display: block;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n    display: inline;\n\n    &:not(:last-child):after{\n        content: \',\';\n        margin: 0 1rem 0 0;\n        display: inline-block;\n    }\n'], ['\n    display: inline;\n\n    &:not(:last-child):after{\n        content: \',\';\n        margin: 0 1rem 0 0;\n        display: inline-block;\n    }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  font-weight: bold;\n  color: ', ';\n  display: inline-block;\n  position: relative;\n  text-decoration: underline;\n  transition: 0.3s;\n  padding: ', ' 0 ', ' 0;\n\n  &:hover {\n      color: ', ';\n      transition: 0.3s;\n  }\n'], ['\n  font-weight: bold;\n  color: ', ';\n  display: inline-block;\n  position: relative;\n  text-decoration: underline;\n  transition: 0.3s;\n  padding: ', ' 0 ', ' 0;\n\n  &:hover {\n      color: ', ';\n      transition: 0.3s;\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: block;\n'], ['\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: block;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(37);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(6);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactIntl = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Section = _styledComponents2.default.section(_templateObject);
	
	var Header = _styledComponents2.default.header(_templateObject2, function (_ref) {
	  var theme = _ref.theme;
	  return theme.scale(-3);
	});
	
	var Li = _styledComponents2.default.li(_templateObject3);
	
	var A = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject4, function (_ref2) {
	  var theme = _ref2.theme;
	  return theme.colors.yellow;
	}, function (_ref3) {
	  var theme = _ref3.theme;
	  return theme.scale(-2);
	}, function (_ref4) {
	  var theme = _ref4.theme;
	  return theme.scale(-2);
	}, function (_ref5) {
	  var theme = _ref5.theme;
	  return theme.colors.white;
	});
	
	var Tag = function Tag(_ref6) {
	  var tag = _ref6.tag;
	
	  return _react2.default.createElement(
	    Li,
	    null,
	    _react2.default.createElement(
	      A,
	      { to: tag.link },
	      tag.tag
	    )
	  );
	};
	
	Tag.propTypes = {
	  tag: _propTypes2.default.object
	};
	
	var Ul = _styledComponents2.default.ul(_templateObject5);
	
	var Tags = function Tags(props) {
	  if (!props.tags || props.tags.length === 0) return null;
	
	  return _react2.default.createElement(
	    Section,
	    null,
	    _react2.default.createElement(
	      Header,
	      null,
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'tags' })
	    ),
	    _react2.default.createElement(
	      Ul,
	      null,
	      (props.tags || []).map(function (tag, i) {
	        return _react2.default.createElement(Tag, { tag: tag, key: i });
	      })
	    )
	  );
	};
	
	Tags.propTypes = {
	  tags: _propTypes2.default.array
	};
	
	exports.default = Tags;
	module.exports = exports['default'];

/***/ }),

/***/ 493:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  text-align: center;\n  font-size: ', ';\n  font-weight: bold;\n  color: ', ';\n  width: 100%;\n  display: block;\n  padding-top: 1rem;\n'], ['\n  text-align: center;\n  font-size: ', ';\n  font-weight: bold;\n  color: ', ';\n  width: 100%;\n  display: block;\n  padding-top: 1rem;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  margin: ', ';\n  padding: ', ';\n'], ['\n  margin: ', ';\n  padding: ', ';\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  padding-bottom: 0;\n  text-align: center;\n  font-size: ', ';\n'], ['\n  padding-bottom: 0;\n  text-align: center;\n  font-size: ', ';\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  margin: 0 0 ', ' 0;\n\n  p > code {\n    color: ', ';\n    font-size: ', ';\n    margin: ', ';\n    padding: ', ';\n    background-color: ', ';\n    border-radius: ', ';\n  }\n\n  .gatsby-highlight{\n    margin:', ';\n    padding:', ';\n    background-color: ', ';\n    display: flex;\n    border-radius: ', ';\n    overflow: auto;\n\n    code {\n      color: ', ';\n    }\n\n    pre{\n      width: 100%;\n      border: 2px solid ', ';\n    }\n  }\n\n  a{\n    color: ', ';\n  }\n\n  h1{\n    margin:', ';\n    padding:', ';\n    font-size:', ';\n  }\n\n  h2{\n    margin:', ';\n    padding:', ';\n    font-size:', ';\n  }\n\n  h3{\n    margin:', ';\n    padding:', ';\n    font-size:', ';\n  }\n\n  h4{\n    margin:', ';\n    padding:', ';\n    font-size:', ';\n  }\n\n  h5{\n    margin:', ';\n    padding:', ';\n    font-size:', ';\n  }\n\n  h6{\n    margin:', ';\n    padding:', ';\n    font-size:', ';\n  }\n\n  p{\n    margin:', ';\n    padding:', ';\n    font-size: ', ';\n    line-height: ', ';\n  }\n\n  & > p:first-of-type::first-letter {\n      font-size: ', ';\n      color: ', ';\n      float: left;\n      line-height: ', ';\n      padding: ', ';\n      margin: ', ';\n  }\n\n  strong{\n    font-weight: bold;\n  }\n\n  ul, ol {\n    margin:', ';\n    padding:', ';\n    font-size:', ';    \n  }\n\n  ul {\n    list-style: disc;\n  }\n\n  ol {\n    list-style: decimal;\n  }\n\n  li {\n    padding-top: 1rem;\n  }\n\n  blockquote {\n    font-style: italic;\n    margin: 0;\n    padding: ', ';    \n    position: relative;\n    text-align: center;\n    color: ', ';\n  }\n\n  blockquote:before {\n    line-height: 1.45;\n    display: block;\n    content: "\\201C";\n    position: absolute;\n    top: -', ';\n    left: -', ';\n    font-size: ', ';\n    color: ', ';\n  }\n\n  blockquote:after {\n    display: block;\n    content: "\\201D";\n    position: absolute;\n    bottom: -', ';\n    right: ', ';\n    font-size: ', ';\n    color: ', ';\n  }\n\n  blockquote cite {\n    color: ', ';\n    font-size: ', ';\n    display: block;\n  }\n     \n  blockquote cite:before {\n    content: "\\2014 \\2009";\n  }\n\n  img {\n    max-width: 100%;\n  }\n'], ['\n  margin: 0 0 ', ' 0;\n\n  p > code {\n    color: ', ';\n    font-size: ', ';\n    margin: ', ';\n    padding: ', ';\n    background-color: ', ';\n    border-radius: ', ';\n  }\n\n  .gatsby-highlight{\n    margin:', ';\n    padding:', ';\n    background-color: ', ';\n    display: flex;\n    border-radius: ', ';\n    overflow: auto;\n\n    code {\n      color: ', ';\n    }\n\n    pre{\n      width: 100%;\n      border: 2px solid ', ';\n    }\n  }\n\n  a{\n    color: ', ';\n  }\n\n  h1{\n    margin:', ';\n    padding:', ';\n    font-size:', ';\n  }\n\n  h2{\n    margin:', ';\n    padding:', ';\n    font-size:', ';\n  }\n\n  h3{\n    margin:', ';\n    padding:', ';\n    font-size:', ';\n  }\n\n  h4{\n    margin:', ';\n    padding:', ';\n    font-size:', ';\n  }\n\n  h5{\n    margin:', ';\n    padding:', ';\n    font-size:', ';\n  }\n\n  h6{\n    margin:', ';\n    padding:', ';\n    font-size:', ';\n  }\n\n  p{\n    margin:', ';\n    padding:', ';\n    font-size: ', ';\n    line-height: ', ';\n  }\n\n  & > p:first-of-type::first-letter {\n      font-size: ', ';\n      color: ', ';\n      float: left;\n      line-height: ', ';\n      padding: ', ';\n      margin: ', ';\n  }\n\n  strong{\n    font-weight: bold;\n  }\n\n  ul, ol {\n    margin:', ';\n    padding:', ';\n    font-size:', ';    \n  }\n\n  ul {\n    list-style: disc;\n  }\n\n  ol {\n    list-style: decimal;\n  }\n\n  li {\n    padding-top: 1rem;\n  }\n\n  blockquote {\n    font-style: italic;\n    margin: 0;\n    padding: ', ';    \n    position: relative;\n    text-align: center;\n    color: ', ';\n  }\n\n  blockquote:before {\n    line-height: 1.45;\n    display: block;\n    content: "\\\\201C";\n    position: absolute;\n    top: -', ';\n    left: -', ';\n    font-size: ', ';\n    color: ', ';\n  }\n\n  blockquote:after {\n    display: block;\n    content: "\\\\201D";\n    position: absolute;\n    bottom: -', ';\n    right: ', ';\n    font-size: ', ';\n    color: ', ';\n  }\n\n  blockquote cite {\n    color: ', ';\n    font-size: ', ';\n    display: block;\n  }\n     \n  blockquote cite:before {\n    content: "\\\\2014 \\\\2009";\n  }\n\n  img {\n    max-width: 100%;\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  max-width: 40rem;\n  height: 20rem;\n  margin: auto;\n  display: block;\n'], ['\n  width: 100%;\n  max-width: 40rem;\n  height: 20rem;\n  margin: auto;\n  display: block;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _graphql = __webpack_require__(13);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	var _reactHelmet = __webpack_require__(15);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(6);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _EditBtn = __webpack_require__(449);
	
	var _EditBtn2 = _interopRequireDefault(_EditBtn);
	
	var _Tags = __webpack_require__(457);
	
	var _Tags2 = _interopRequireDefault(_Tags);
	
	var _structuredData = __webpack_require__(174);
	
	var _Time = __webpack_require__(285);
	
	var _Time2 = _interopRequireDefault(_Time);
	
	var _Comments = __webpack_require__(448);
	
	var _Comments2 = _interopRequireDefault(_Comments);
	
	var _Posts = __webpack_require__(170);
	
	var _Posts2 = _interopRequireDefault(_Posts);
	
	var _anchorJs = __webpack_require__(435);
	
	var _anchorJs2 = _interopRequireDefault(_anchorJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Time = (0, _styledComponents2.default)(_Time2.default)(_templateObject, function (props) {
	  return props.theme.blog.post.header.time.fontSize;
	}, function (props) {
	  return props.theme.blog.post.header.time.color;
	});
	
	var Post = _styledComponents2.default.article(_templateObject2, function (props) {
	  return props.theme.blog.post.margin;
	}, function (props) {
	  return props.theme.blog.post.padding;
	});
	
	var H1 = _styledComponents2.default.h1(_templateObject3, function (props) {
	  return props.theme.blog.post.header.fontSize;
	});
	
	var Content = _styledComponents2.default.section(_templateObject4, function (_ref) {
	  var theme = _ref.theme;
	  return theme.scale(6);
	}, function (props) {
	  return props.theme.blog.post.content.code.color;
	}, function (props) {
	  return props.theme.blog.post.content.code.fontSize;
	}, function (props) {
	  return props.theme.blog.post.content.code.margin;
	}, function (props) {
	  return props.theme.blog.post.content.code.padding;
	}, function (props) {
	  return props.theme.blog.post.content.code.backgroundColor;
	}, function (props) {
	  return props.theme.blog.post.content.code.borderRadius;
	}, function (props) {
	  return props.theme.blog.post.content.highlight.margin;
	}, function (props) {
	  return props.theme.blog.post.content.highlight.padding;
	}, function (props) {
	  return props.theme.blog.post.content.highlight.backgroundColor;
	}, function (props) {
	  return props.theme.blog.post.content.highlight.borderRadius;
	}, function (props) {
	  return props.theme.blog.post.content.highlight.code.color;
	}, function (props) {
	  return props.theme.colors.white;
	}, function (props) {
	  return props.theme.blog.post.content.a.color;
	}, function (props) {
	  return props.theme.blog.post.content.h1.margin;
	}, function (props) {
	  return props.theme.blog.post.content.h1.padding;
	}, function (props) {
	  return props.theme.blog.post.content.h1.fontSize;
	}, function (props) {
	  return props.theme.blog.post.content.h2.margin;
	}, function (props) {
	  return props.theme.blog.post.content.h2.padding;
	}, function (props) {
	  return props.theme.blog.post.content.h2.fontSize;
	}, function (props) {
	  return props.theme.blog.post.content.h3.margin;
	}, function (props) {
	  return props.theme.blog.post.content.h3.padding;
	}, function (props) {
	  return props.theme.blog.post.content.h3.fontSize;
	}, function (props) {
	  return props.theme.blog.post.content.h4.margin;
	}, function (props) {
	  return props.theme.blog.post.content.h4.padding;
	}, function (props) {
	  return props.theme.blog.post.content.h4.fontSize;
	}, function (props) {
	  return props.theme.blog.post.content.h5.margin;
	}, function (props) {
	  return props.theme.blog.post.content.h5.padding;
	}, function (props) {
	  return props.theme.blog.post.content.h5.fontSize;
	}, function (props) {
	  return props.theme.blog.post.content.h6.margin;
	}, function (props) {
	  return props.theme.blog.post.content.h6.padding;
	}, function (props) {
	  return props.theme.blog.post.content.h6.fontSize;
	}, function (props) {
	  return props.theme.blog.post.content.p.margin;
	}, function (props) {
	  return props.theme.blog.post.content.p.padding;
	}, function (props) {
	  return props.theme.p.fontSize;
	}, function (props) {
	  return props.theme.p.lineHeight;
	}, function (props) {
	  return props.theme.p.firstLetter.fontSize;
	}, function (props) {
	  return props.theme.p.firstLetter.color;
	}, function (props) {
	  return props.theme.p.firstLetter.lineHeight;
	}, function (props) {
	  return props.theme.p.firstLetter.padding;
	}, function (props) {
	  return props.theme.p.firstLetter.margin;
	}, function (props) {
	  return props.theme.blog.post.content.ul.margin;
	}, function (props) {
	  return props.theme.blog.post.content.ul.padding;
	}, function (props) {
	  return props.theme.blog.post.content.ul.fontSize;
	}, function (_ref2) {
	  var theme = _ref2.theme;
	  return theme.scale(3);
	}, function (_ref3) {
	  var theme = _ref3.theme;
	  return theme.colors.white;
	}, function (_ref4) {
	  var theme = _ref4.theme;
	  return theme.scale(-4);
	}, function (_ref5) {
	  var theme = _ref5.theme;
	  return theme.scale(1);
	}, function (_ref6) {
	  var theme = _ref6.theme;
	  return theme.scale(10);
	}, function (_ref7) {
	  var theme = _ref7.theme;
	  return theme.colors.white;
	}, function (_ref8) {
	  var theme = _ref8.theme;
	  return theme.scale(6);
	}, function (_ref9) {
	  var theme = _ref9.theme;
	  return theme.scale(1);
	}, function (_ref10) {
	  var theme = _ref10.theme;
	  return theme.scale(10);
	}, function (_ref11) {
	  var theme = _ref11.theme;
	  return theme.colors.white;
	}, function (_ref12) {
	  var theme = _ref12.theme;
	  return theme.colors.blue;
	}, function (_ref13) {
	  var theme = _ref13.theme;
	  return theme.scale(-1);
	});
	
	var Iframe = _styledComponents2.default.iframe(_templateObject5);
	
	var getYoutube = function getYoutube(markdownRemark) {
	  var youtubeId = markdownRemark.frontmatter.youtubeId;
	  return youtubeId ? _react2.default.createElement(Iframe, {
	    width: '560',
	    height: '315',
	    src: 'https://www.youtube.com/embed/' + youtubeId,
	    frameBorder: '0',
	    allowFullScreen: true }) : null;
	};
	
	var BlogPostRoute = function (_React$PureComponent) {
	  _inherits(BlogPostRoute, _React$PureComponent);
	
	  function BlogPostRoute() {
	    _classCallCheck(this, BlogPostRoute);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  BlogPostRoute.prototype.componentDidMount = function componentDidMount() {
	    var anchors = new _anchorJs2.default();
	    anchors.add('h1, h2');
	  };
	
	  BlogPostRoute.prototype.render = function render() {
	    var markdownRemark = this.props.data.markdownRemark;
	    var langKey = this.props.pathContext.langKey;
	
	    var youtube = getYoutube(markdownRemark);
	    var structuredData = (0, _structuredData.getStructuredData)(markdownRemark);
	    var url = 'https://angeloocana.com' + markdownRemark.fields.slug;
	
	    var tags = _react2.default.createElement(_Tags2.default, { tags: markdownRemark.fields.tagSlugs });
	
	    return _react2.default.createElement(
	      Post,
	      null,
	      _react2.default.createElement(_reactHelmet2.default, {
	        title: '' + markdownRemark.frontmatter.title,
	        meta: [{ name: 'description', content: markdownRemark.excerpt }]
	      }),
	      _react2.default.createElement('script', {
	        type: 'application/ld+json',
	        dangerouslySetInnerHTML: { __html: structuredData }
	      }),
	      _react2.default.createElement(
	        'header',
	        null,
	        _react2.default.createElement(
	          H1,
	          null,
	          markdownRemark.frontmatter.title
	        ),
	        _react2.default.createElement(Time, {
	          pubdate: true,
	          date: markdownRemark.frontmatter.date,
	          langKey: langKey
	        })
	      ),
	      _react2.default.createElement(_EditBtn2.default, {
	        fileAbsolutePath: markdownRemark.fileAbsolutePath,
	        currentLangKey: langKey
	      }),
	      tags,
	      youtube,
	      _react2.default.createElement(Content, { dangerouslySetInnerHTML: { __html: markdownRemark.html } }),
	      _react2.default.createElement(_Comments2.default, {
	        shortname: 'angeloocana-com',
	        identifier: markdownRemark.fields.slug,
	        title: markdownRemark.frontmatter.title,
	        url: url
	      }),
	      tags,
	      _react2.default.createElement(_Posts2.default, {
	        posts: markdownRemark.fields.readNextPosts,
	        langKey: langKey,
	        showBtnMorePosts: true,
	        title: 'posts.readNext'
	      })
	    );
	  };
	
	  return BlogPostRoute;
	}(_react2.default.PureComponent);
	
	BlogPostRoute.propTypes = {
	  data: _propTypes2.default.object,
	  pathContext: _propTypes2.default.object
	};
	
	exports.default = BlogPostRoute;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-blog-post-js-15b108038cb991dd8589.js